if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        this.handleOutsideClick = this.handleOutsideClick.bind(this);
        this.addEventListener('click', this.handleModelingClick.bind(this));
      }

      /**
       * ZUCK 2026-08-27 — a modelagem (`product-modeling-picker`) nao e uma opcao
       * de variante: sao <a href> para um PRODUTO irmao (Tradicional <-> Alca
       * Reta). Na PDP navegar e o comportamento certo; na faixa do card, nao —
       * trocar de modelagem tem que trocar o que vai pro carrinho sem sair da
       * pagina. Aqui o clique e interceptado e a faixa recarrega o irmao no lugar.
       * O href ja vem com `?variant=` da cor equivalente quando ela existe no
       * irmao, entao a cor escolhida sobrevive a troca.
       */
      handleModelingClick(event) {
        const link = event.target.closest('a.product-modeling-picker__option--link');
        if (!link || !this.modalContent || !this.modalContent.contains(link)) return;

        const url = link.getAttribute('href');
        if (!url) return;

        event.preventDefault();
        event.stopPropagation();
        this.swapModeling(url);
      }

      swapModeling(productUrl) {
        if (this.swappingModeling) return;
        this.swappingModeling = true;
        this.allowImageSync = true;
        this.modalContent.classList.add('quick-add-modal__content-info--loading');

        this.fetchProductElement(productUrl)
          .then((productElement) => {
            if (!productElement) return;
            this.injectProduct(productElement);
          })
          .finally(() => {
            this.swappingModeling = false;
            this.modalContent.classList.remove('quick-add-modal__content-info--loading');
          });
      }

      injectProduct(productElement) {
        this.preprocessHTML(productElement);
        HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
        this.runInjectedScripts(this.modalContent);
        this.initQuickAddGallery(this.modalContent);

        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) window.ProductModel.loadShopifyXR();

        this.watchContent();
        this.armImageSyncOnInteraction();
        this.armKitSubmit();
        this.refreshBar();
        this.renderKitChrome();
      }

      armKitSubmit() {
        if (!this.modalContent || this.kitSubmitArmed) return;
        this.kitSubmitArmed = true;
        this.handleKitSubmitBound = this.handleKitSubmit.bind(this);
        // captura: precisa correr antes do <product-form> do tema, que senao
        // mandaria a peca sozinha para o carrinho como se fosse o produto todo.
        this.modalContent.addEventListener('click', this.handleKitSubmitBound, true);
      }

      /**
       * ZUCK 2026-08-28 — a foto do card acompanha a ESCOLHA do cliente, nunca a
       * abertura. Enquanto ninguem mexeu na faixa o sync fica desligado (era o que
       * fazia a foto piscar ao abrir); no primeiro `change` dentro da faixa —
       * trocar de cor, de tamanho — ele liga e a foto do card passa a seguir a
       * variante selecionada.
       */
      armImageSyncOnInteraction() {
        if (!this.modalContent || this.imageSyncArmed) return;
        this.imageSyncArmed = true;
        this.modalContent.addEventListener('change', () => {
          this.allowImageSync = true;
        });
      }

      /**
       * O tema re-renderiza o <product-info> a cada troca de variante
       * (`handleUpdateProductInfo` reescreve o `variant-selects`), o que apagaria
       * as setas do carrossel de cores. Em vez de tentar prever cada re-render,
       * um observer refaz o estado da faixa sempre que o conteudo muda.
       */
      watchContent() {
        if (this.contentObserver || !this.modalContent) return;
        this.contentObserver = new MutationObserver(() => {
          if (this.refreshQueued) return;
          this.refreshQueued = true;
          requestAnimationFrame(() => {
            this.refreshQueued = false;
            this.refreshBar();
          });
        });
        this.contentObserver.observe(this.modalContent, { childList: true, subtree: true });
      }

      /**
       * ZUCK 2026-08-28 — `syncCardImage()` NAO roda ao abrir. A foto do card so
       * muda quando a modelagem muda (que e o que foi pedido). Rodando na abertura
       * ela trocava a imagem do card pela `featured_image` da variante selecionada
       * — quase sempre um arquivo diferente — e o card piscava para outra foto
       * assim que a faixa aparecia.
       * Depois de uma troca de modelagem o sync continua ligado, para a foto
       * acompanhar tambem a cor escolhida dentro da faixa.
       */
      refreshBar() {
        this.ensureOptionScrollers();
        if (this.allowImageSync) this.syncCardImage();
        this.renderKitChrome();
      }

      // ---- carrossel horizontal das linhas de opcao -------------------------

      ensureOptionScrollers() {
        if (!this.modalContent) return;

        // a linha de modelagem tambem estoura em card estreito ("Tradicional" +
        // "Alca Reta" nao cabem em 178px), entao ela entra no mesmo tratamento.
        this.modalContent
          .querySelectorAll('fieldset.product-form__input, .product-modeling-picker__options')
          .forEach((row) => {
          const overflows = row.scrollWidth > row.clientWidth + 2;
          const existing =
            row.parentElement && row.parentElement.classList.contains('qa-scroller') ? row.parentElement : null;

          if (!overflows) {
            if (existing) existing.replaceWith(row);
            return;
          }
          if (existing) {
            this.updateScrollerState(existing, row);
            return;
          }

          const wrap = document.createElement('div');
          wrap.className = 'qa-scroller';
          row.parentNode.insertBefore(wrap, row);
          wrap.appendChild(row);

          ['prev', 'next'].forEach((dir) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'qa-scroller__nav qa-scroller__nav--' + dir;
            btn.setAttribute('aria-label', dir === 'prev' ? 'Ver cores anteriores' : 'Ver mais cores');
            btn.innerHTML =
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
              '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.6" ' +
              'stroke-linecap="round" stroke-linejoin="round"/></svg>';
            btn.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();
              row.scrollBy({
                left: (dir === 'prev' ? -1 : 1) * Math.max(60, Math.round(row.clientWidth * 0.7)),
                behavior: 'smooth',
              });
            });
            wrap.appendChild(btn);
          });

          row.addEventListener('scroll', () => this.updateScrollerState(wrap, row), { passive: true });
          this.updateScrollerState(wrap, row);
        });
      }

      updateScrollerState(wrap, row) {
        const max = row.scrollWidth - row.clientWidth;
        wrap.classList.toggle('qa-scroller--at-start', row.scrollLeft <= 2);
        wrap.classList.toggle('qa-scroller--at-end', row.scrollLeft >= max - 2);
      }

      // ---- imagem do card acompanha a variante escolhida na faixa -----------

      /**
       * Trocar de modelagem (ou de cor) tem que trocar a foto do card. A variante
       * selecionada ja vem serializada no `script[data-selected-variant]` que o
       * variant-picker emite, e o `featured_image.src` dela e exatamente "a foto
       * da outra modelagem na cor atual" — nao precisa de request extra.
       * A foto original e guardada e restaurada ao fechar, porque o card continua
       * sendo o do produto original: titulo, preco e link nao mudam.
       */
      syncCardImage() {
        if (!this.anchorCard || !this.modalContent) return;

        const script = this.modalContent.querySelector('script[data-selected-variant]');
        if (!script) return;

        let src;
        try {
          src = JSON.parse(script.textContent)?.featured_image?.src;
        } catch (e) {
          return;
        }
        if (!src || src === this.appliedCardImage) return;

        const images = this.anchorCard.querySelectorAll('.card__media img');
        if (!images.length) return;

        const sep = src.includes('?') ? '&' : '?';
        const srcset = [165, 360, 533, 720, 940].map((w) => src + sep + 'width=' + w + ' ' + w + 'w').join(', ');
        images.forEach((img) => {
          // o original vai no proprio elemento: guardar referencias de nos deixava
          // a restauracao escrevendo em nos ja substituidos por um re-render, e a
          // foto trocada ficava presa no card.
          if (!img.hasAttribute('data-qa-original-src')) {
            img.setAttribute('data-qa-original-src', img.getAttribute('src') || '');
            img.setAttribute('data-qa-original-srcset', img.getAttribute('srcset') || '');
          }
          img.setAttribute('src', src + sep + 'width=533');
          img.setAttribute('srcset', srcset);
        });
        this.appliedCardImage = src;
      }

      /** Devolve QUALQUER foto trocada que tenha sobrado na pagina. */
      static restoreAllCardImages(scope) {
        (scope || document).querySelectorAll('img[data-qa-original-src]').forEach((img) => {
          const src = img.getAttribute('data-qa-original-src');
          const srcset = img.getAttribute('data-qa-original-srcset');
          if (src) img.setAttribute('src', src);
          else img.removeAttribute('src');
          if (srcset) img.setAttribute('srcset', srcset);
          else img.removeAttribute('srcset');
          img.removeAttribute('data-qa-original-src');
          img.removeAttribute('data-qa-original-srcset');
        });
      }

      restoreCardImage() {
        QuickAddModal.restoreAllCardImages(this.anchorCard);
        this.appliedCardImage = null;
        this.allowImageSync = false;
        this.imageSyncArmed = false;
        this.kit = null;
        this.kitPicks = [];
        this.kitStep = 0;
        this.kitBusy = false;
        this.kitSubmitArmed = false;
      }

      /**
       * ZUCK 2026-08-27 — ModalDialog.connectedCallback() move o elemento para o
       * <body>, o que serve a um modal de tela cheia mas impede ancorar o popover
       * ao card. Aqui ele fica onde foi renderizado, dentro do card.
       */
      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        const section = this.closest('.shopify-section');
        if (section) this.dataset.section = section.id.replace('shopify-section-', '');
      }

      /**
       * ZUCK 2026-08-28 — fechar ao interagir fora da faixa.
       * `pointerdown` e nao `click`: arrastar um carrossel de outra secao nunca
       * dispara `click`, entao a faixa ficava aberta enquanto a pagina se movia
       * embaixo dela. Em captura, para valer mesmo que o alvo pare a propagacao.
       * O proprio botao que abriu e ignorado — senao o pointerdown fecharia e o
       * click seguinte reabriria, piscando.
       */
      handleOutsideClick(event) {
        if (!this.hasAttribute('open') || this.closing) return;
        if (event.target.closest('quick-add-modal') === this) return;
        if (this.openedBy && event.target.closest('modal-opener') === this.openedBy.closest('modal-opener')) return;
        // `true` = nao devolver o foco ao botao que abriu: devolver dispara
        // `.focus()` nele e o navegador rola a pagina de volta para aquele card.
        this.hide(true);
      }

      /**
       * ZUCK 2026-08-27 — o ModalDialog fecha tirando o atributo `open`, o que faz a
       * faixa sumir num quadro. Aqui o fechamento roda a animacao de saida antes de
       * desmontar: `hide()` so marca e espera, `finishHide()` faz a limpeza real.
       * Tudo que desmonta (limpar innerHTML, restaurar a foto do card) fica no
       * finishHide, senao a faixa esvaziaria no meio da animacao.
       */
      hide(preventFocus = false) {
        // fora imediatamente: um segundo clique nao pode reentrar no fechamento
        document.removeEventListener('pointerdown', this.handleOutsideClick, true);
        document.removeEventListener('click', this.handleOutsideClick, true);
        if (this.closing) return;

        const panel = this.querySelector('.quick-add-modal__content');
        const reduceMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.hasAttribute('open') || !panel || reduceMotion) {
          this.finishHide(preventFocus);
          return;
        }

        this.closing = true;
        panel.classList.add('is-closing');

        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          panel.classList.remove('is-closing');
          this.closing = false;
          this.finishHide(preventFocus);
        };
        panel.addEventListener('animationend', finish, { once: true });
        // rede de seguranca: se a animacao nao disparar, nao deixa a faixa presa aberta
        setTimeout(finish, 400);
      }

      /** Fecha na hora, sem animacao e sem devolver o foco. */
      hideNow() {
        document.removeEventListener('pointerdown', this.handleOutsideClick, true);
        document.removeEventListener('click', this.handleOutsideClick, true);
        if (this.closing) {
          this.closing = false;
          this.querySelector('.quick-add-modal__content')?.classList.remove('is-closing');
        }
        this.finishHide(true);
      }

      finishHide(preventFocus = false) {
        if (this.contentObserver) {
          this.contentObserver.disconnect();
          this.contentObserver = null;
        }
        this.restoreCardImage();
        if (this.anchorCard) this.anchorCard.classList.remove('has-quick-add-popover');
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        const modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        if (modalContent) modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      /**
       * ZUCK 2026-08-27 — Quick add simplificado.
       * O modal carrega o template `product.quick-add` (templates/product.quick-add.json)
       * em vez da PDP inteira: so titulo, preco, seletor de variante (cor/tamanho) e
       * adicionar ao carrinho. Se o template nao existir na loja, cai de volta na URL
       * normal do produto para nao quebrar o quick add.
       */
      static QUICK_ADD_VIEW = 'quick-add';

      buildQuickAddURL(productUrl, variantId) {
        try {
          const url = new URL(productUrl, window.location.origin);
          url.searchParams.set('view', QuickAddModal.QUICK_ADD_VIEW);
          if (variantId) url.searchParams.set('variant', variantId);
          return url.pathname + url.search;
        } catch (e) {
          return productUrl;
        }
      }

      /**
       * ZUCK 2026-08-28 — modo kit.
       * Um kit nao e uma variante: a pagina do kit monta N pecas do produto
       * unitario e manda N linhas (`items[][id]`) para o carrinho. Adicionar a
       * variante do proprio kit daria UMA linha com as pecas todas iguais, e
       * qualquer regra presa ao produto unitario (brinde, bump) deixaria de ver
       * as pecas. Entao a faixa monta as pecas uma a uma, igual a pagina.
       * O card so entra nesse modo se souber as duas coisas — quantas pecas e
       * qual o produto unitario; sem isso segue como card normal.
       */
      readKitConfig(opener) {
        const card = opener.closest('[data-kit-units][data-kit-unit-url]');
        if (!card) return null;
        const units = parseInt(card.getAttribute('data-kit-units') || '0', 10);
        const unitUrl = card.getAttribute('data-kit-unit-url');
        if (!(units > 1) || !unitUrl) return null;
        return { units, unitUrl };
      }

      get isLastKitStep() {
        return !this.kit || this.kitStep >= this.kit.units - 1;
      }

      /** Cabecalho "PECA n DE N" + rotulo do botao, redesenhado a cada passo. */
      renderKitChrome() {
        if (!this.kit || !this.modalContent) return;

        const info = this.modalContent;
        let head = info.querySelector('.qa-kit-step');
        if (!head) {
          head = document.createElement('div');
          head.className = 'qa-kit-step';
          info.insertBefore(head, info.firstChild);
        }
        const dots = Array.from({ length: this.kit.units }, (_, i) =>
          '<span class="qa-kit-step__dot' + (i <= this.kitStep ? ' is-done' : '') + '"></span>'
        ).join('');
        head.innerHTML =
          '<span class="qa-kit-step__label">Peça ' + (this.kitStep + 1) + ' de ' + this.kit.units + '</span>' +
          '<span class="qa-kit-step__dots">' + dots + '</span>';

        const submit = info.querySelector('button[name=add]');
        if (submit) {
          const label = submit.querySelector('span') || submit;
          label.textContent = this.isLastKitStep ? 'Adicionar ao carrinho' : 'Próxima peça';
        }
      }

      /** Intercepta o botao: nos passos intermediarios ele avanca, nao adiciona. */
      handleKitSubmit(event) {
        if (!this.kit) return;
        const btn = event.target.closest('button[name=add]');
        if (!btn || !this.modalContent.contains(btn)) return;

        event.preventDefault();
        event.stopPropagation();
        if (this.kitBusy) return;

        const idInput = this.modalContent.querySelector('form [name="id"]');
        const variantId = idInput && idInput.value;
        if (!variantId || idInput.disabled) return;

        this.kitPicks[this.kitStep] = variantId;

        if (!this.isLastKitStep) {
          this.kitStep += 1;
          this.kitBusy = true;
          this.modalContent.classList.add('quick-add-modal__content-info--loading');
          this.fetchProductElement(this.kit.unitUrl)
            .then((productElement) => {
              if (productElement) this.injectProduct(productElement);
            })
            .finally(() => {
              this.kitBusy = false;
              this.modalContent.classList.remove('quick-add-modal__content-info--loading');
            });
          return;
        }

        this.addKitToCart(btn);
      }

      /** Manda as N pecas como N linhas, do mesmo jeito que a pagina do kit. */
      addKitToCart(button) {
        this.kitBusy = true;
        button.classList.add('loading');
        button.setAttribute('aria-disabled', 'true');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const payload = {
          items: this.kitPicks.filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 })),
        };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          payload.sections = cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(payload),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showKitError(response.description || response.message);
              return;
            }
            if (cart && typeof cart.renderContents === 'function') {
              cart.setActiveElement && cart.setActiveElement(this.openedBy);
              this.hide(true);
              cart.renderContents(response);
            } else {
              this.hide(true);
            }
          })
          .catch(() => this.showKitError())
          .finally(() => {
            this.kitBusy = false;
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      showKitError(message) {
        const wrapper = this.modalContent.querySelector('.product-form__error-message-wrapper');
        const target = wrapper && wrapper.querySelector('.product-form__error-message');
        if (!wrapper || !target) return;
        target.textContent = message || 'Nao foi possivel adicionar o kit. Tente novamente.';
        wrapper.removeAttribute('hidden');
      }

      /**
       * ZUCK 2026-08-28 — a cor escolhida no card tem que valer na faixa.
       * O swatch ativo do card (`.card-product-swatch-btn.is-active`) carrega o
       * `data-variant-id`; abrindo a faixa com `?variant=` ela ja vem com aquela
       * cor marcada, em vez da variante padrao do produto.
       */
      selectedCardVariantId(opener) {
        const card = opener.closest('.product-card-wrapper') || opener.closest('.card-wrapper');
        const active = card && card.querySelector('.card-product-swatch-btn.is-active');
        return (active && active.getAttribute('data-variant-id')) || null;
      }

      fetchProductElement(productUrl, variantId) {
        const parse = (responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          return responseHTML.querySelector('product-info');
        };

        return fetch(this.buildQuickAddURL(productUrl, variantId))
          .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
          .then((responseText) => parse(responseText) || Promise.reject('no product-info'))
          .catch(() =>
            fetch(productUrl)
              .then((response) => response.text())
              .then(parse)
          );
      }

      show(opener) {
        // rede de seguranca: nenhuma foto trocada pode sobrar de uma sessao anterior
        QuickAddModal.restoreAllCardImages(document);

        // abrir a faixa de um card fecha a de qualquer outro — de imediato, sem
        // animacao: se a desmontagem da outra faixa acontecesse depois, o
        // `removeTrapFocus()` dela arrancaria o focus trap que esta acabou de
        // instalar, alem de mexer no foco (e no scroll) fora de hora.
        document.querySelectorAll('quick-add-modal[open]').forEach((other) => {
          if (other !== this && typeof other.hideNow === 'function') other.hideNow();
        });

        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        this.kit = this.readKitConfig(opener);
        this.kitPicks = [];
        this.kitStep = 0;

        this.fetchProductElement(
          this.kit ? this.kit.unitUrl : opener.getAttribute('data-product-url'),
          this.kit ? null : this.selectedCardVariantId(opener)
        )
          .then((productElement) => {
            if (!productElement) return;

            this.anchorToCard(opener);
            this.injectProduct(productElement);
            // `overflow: clip` ja impede, mas se algum navegador cair para
            // `hidden` o foco na faixa rolaria o card e deslocaria a foto.
            if (this.anchorCard) {
              this.anchorCard.scrollTop = 0;
              this.anchorCard.scrollLeft = 0;
            }
            super.show(opener);
            // super.show() trava o scroll do body — correto para um modal, errado
            // para um popover que vive dentro do card.
            document.body.classList.remove('overflow-hidden');
            if (this.anchorCard) {
              this.anchorCard.scrollTop = 0;
              this.anchorCard.scrollLeft = 0;
            }
            setTimeout(() => {
              document.addEventListener('pointerdown', this.handleOutsideClick, true);
              document.addEventListener('click', this.handleOutsideClick, true);
            }, 0);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      /**
       * Move o popover para dentro do card que o abriu, para que ele se posicione
       * em relacao ao card e nao a viewport.
       */
      anchorToCard(opener) {
        const card =
          opener.closest('.card__inner') || opener.closest('.card-wrapper') || opener.closest('.card');
        if (!card) return;
        if (this.parentElement !== card) card.appendChild(this);
        card.classList.add('has-quick-add-popover');
        this.anchorCard = card;
      }

      preprocessHTML(productElement) {
        // ZUCK 2026-08-27: a faixa tem paleta propria (fundo escuro translucido
        // sobre a foto), entao NAO copiamos `color-*`/`gradient` da secao — essas
        // classes pintavam a faixa de branco.
        this.modalContent.classList.add('quick-add-modal__content-info--card');
        this.preventDuplicatedIDs(productElement);
        this.stripLayoutClasses(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      /**
       * ZUCK 2026-08-27 — a faixa vive DENTRO da secao do card (o ModalDialog nao
       * move mais para o <body>), entao a markup injetada passa a receber as
       * regras de grid da secao hospedeira. Numa secao com 5 colunas isso deixava
       * o `.product__info-wrapper.grid__item` com 27px de largura dentro de um
       * card de 232px. Essas regras sao escopadas por `#shopify-section-...`,
       * ou seja, tem ID e nao da para vencer por especificidade — o certo e tirar
       * os ganchos: a faixa nao usa o grid do Dawn para nada.
       */
      stripLayoutClasses(productElement) {
        productElement.querySelectorAll('.grid, .grid__item, .page-width').forEach((el) => {
          el.classList.remove('grid', 'grid__item', 'page-width');
          Array.from(el.classList).forEach((name) => {
            if (name.startsWith('grid--')) el.classList.remove(name);
          });
        });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      runInjectedScripts(container) {
        if (!container) return;

        container.querySelectorAll('script').forEach((oldScript) => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.replaceWith(newScript);
        });
      }

      initQuickAddGallery(container) {
        if (!container) return;

        const galleryList = container.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        container.querySelectorAll('.slider-buttons').forEach((el) => {
          el.classList.remove('quick-add-hidden');
        });

        const getSelectedColor = () => {
          const checked = container.querySelector(
            'input[type="radio"][name*="Cor"]:checked, input[type="radio"][name*="Color"]:checked, input[type="radio"][name*="cor"]:checked'
          );
          if (checked) return checked.value.trim().toLowerCase();

          const selectedSwatch = container.querySelector(
            '.product-form__input--swatch input:checked + label, .swatch-input__input:checked + label'
          );
          if (selectedSwatch) {
            return (
              selectedSwatch.getAttribute('title') ||
              selectedSwatch.textContent ||
              ''
            )
              .trim()
              .toLowerCase();
          }

          const firstSlide = galleryList.querySelector('.product__media-item[data-media-group]');
          return (firstSlide?.dataset.mediaGroup || '').trim().toLowerCase();
        };

        const revealSlidesForSelectedColor = () => {
          const slides = [...galleryList.querySelectorAll('.product__media-item[data-media-group]')];
          if (!slides.length) return;

          const groups = slides
            .map((slide) => (slide.dataset.mediaGroup || '').trim().toLowerCase())
            .filter(Boolean);
          const selectedColor = getSelectedColor();
          const color =
            selectedColor && groups.includes(selectedColor) ? selectedColor : groups[0];

          let visibleCount = 0;
          slides.forEach((slide) => {
            const show = !color || (slide.dataset.mediaGroup || '').trim().toLowerCase() === color;
            slide.style.display = show ? 'block' : 'none';
            slide.classList.toggle('is-active', show && visibleCount === 0);
            if (show) visibleCount++;
          });

          const counterTotal = container.querySelector('.slider-counter--total');
          const counterCurrent = container.querySelector('.slider-counter--current');
          if (counterTotal) counterTotal.textContent = visibleCount;
          if (counterCurrent) counterCurrent.textContent = visibleCount > 0 ? '1' : '0';

          galleryList.scrollLeft = 0;
        };

        setTimeout(revealSlidesForSelectedColor, 150);
        setTimeout(revealSlidesForSelectedColor, 450);

        container.addEventListener(
          'change',
          (event) => {
            if (event.target.closest('variant-selects, .product-form__input, .swatch-input')) {
              setTimeout(revealSlidesForSelectedColor, 100);
            }
          },
          { passive: true }
        );
      }
    }
  );
}
